var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [
            _vm._v(
              _vm._s(
                _vm.$ct("auto-add-products-with-not-enough-stock-select-groups")
              )
            ),
          ]),
          _c(
            "w-card-content",
            [
              _c("app-product-group-select", {
                attrs: { multi: "" },
                model: {
                  value: _vm.groups,
                  callback: function ($$v) {
                    _vm.groups = $$v
                  },
                  expression: "groups",
                },
              }),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban", disabled: _vm.adding },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check", disabled: _vm.adding },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }